import {
  createRouter as createTanStackRouter,
  type RouterHistory,
} from "@tanstack/react-router";
import { routeTree } from "@/routeTree.gen";

export function getRouter(options?: { history?: RouterHistory }) {
  return createTanStackRouter({
    routeTree,
    history: options?.history,
    scrollRestoration: true,
    defaultPreload: "intent",
  });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
